<div *ngIf="errorMessage" class="alert alert-danger ">
  <small>{{ errorMessage }}</small>
</div>

<div *ngIf="successMessage" class="alert alert-success">
  <small>{{ successMessage }}</small>
</div>

<div class="user-container p-4 min-vh-100">
  <!-- Title + Button side by side -->
  <div class="d-flex align-items-center justify-content-center mb-4 px-5">
    <h2 class="user-title fw-medium fs-2 mb-0">Users in Team {{ teamName }}</h2>
  </div>
  <div class="d-flex justify-content-center mt-3">
    <button
      class="btn btn-user rounded-pill px-4 py-2 fw-bold d-flex align-items-center justify-content-center mb-4 px-5"
      (click)="openAddUserModal()">
      + Add User
    </button>
    <input type="file" class="form-control rounded-pill px-4 py-2 fw-bold mb-4 px-4 ms-auto" accept=".csv , .xls, .xlsx"
      style="max-width: 280px;" (change)="selectedFile($event)" />
    <button
      class="btn btn-user rounded-pill px-4 py-2 fw-bold d-flex align-items-center justify-content-center mb-4 px-5 ms-2"
      (click)="uploadFiles()">
      Bulk Import
    </button>
  </div>

  <!-- Table same as Teams design -->
  <div class=" table-responsive d-flex justify-content-center">
    <table class="table table-hover align-middle text-center border rounded-4 w-auto mt-3">
      <thead class="table-light fs-5">
        <tr>
          <th class="border-end px-4 py-3 align-middle">Name</th>
          <th class="border-end px-4 py-3 align-middle">Email</th>
          <th class="border-end px-4 py-3 align-middle">Is Active</th>
        </tr>
      </thead>

      <tbody *ngIf="users && users.length > 0; else noUserData">
        <tr *ngFor="let user of users" class="cursor-pointer">
          <td class="border-end px-4 py-3 align-middle">{{ user.Name }}</td>
          <td class="border-end px-4 py-3 align-middle">{{ user.Email }}</td>
          <td class="border-end px-4 py-3 align-middle">
            <span [ngClass]="{'text-success': user.IsActive, 'text-danger': !user.IsActive}">
              {{ user.IsActive ? 'Active' : 'Inactive' }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
  <div class="d-flex justify-content-center mt-3">
    <button class="btn btn-back rounded-pill px-4 py-2 fw-bold" (click)="goback()">Back</button>
  </div>
  <ng-template #noUserData>
    <div class="alert alert-warning">No users found.</div>
  </ng-template>
</div>

<div class="modal" id="addUserModal" tabindex="-1" aria-labelledby="addUserModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title" id="addUserModalLabel">Add User</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <!-- Your Add User Component -->
        <app-add-user *ngIf="showAddUserModal" [teamId]="teamId" (userAdded)="onUserAdded($event)"></app-add-user>
      </div>

    </div>
  </div>
</div>

<div class="toast-container position-fixed top-0 end-0 p-3">
  <div #userToast class="toast align-items-center text-bg-success border-0" role="alert" aria-live="assertive"
    aria-atomic="true">
    <div class="d-flex">
      <div class="toast-body">
        User Added Successfully!
      </div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"
        aria-label="Close"></button>
    </div>
  </div>
</div>